<ng-select [items]="items" [(ngModel)]="model"  placeholder="{{placeHolderText}}"  bindValue="value" appendTo="body" 
    [disabled]="disableInput" (change)="modelChange.emit(model)"
    [ngClass]="{ 'is-invalid px-form': (model == undefined) && (submitted == true ) && includeValidation == true}"
    class="dropdown form-control pt-0 pb-0 px-3 flex-grow-1"  type="text"[searchable]="false" [clearable]="false">

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        <span class="ng-value-label ">
            <span *ngIf="(item.selectedText !== undefined) else elseValueText">
                {{item.selectedText}}
            </span>
            <ng-template #elseValueText>
                {{item.value}}
            </ng-template>
        </span>
    </ng-template>

    <ng-template ng-option-tmp class="border-light" let-item="item" let-clear="clear">
        <span class="ng-value-label" [ngClass]="{'text-muted': item.default==true}">
            <span *ngIf="(item.dropdownText !== undefined) else elseSelectedText">
                {{item.dropdownText}}
            </span>
            <ng-template #elseSelectedText>
                <span *ngIf="(item.selectedText  !== undefined) else elseValueText">
                    {{item.selectedText}}
                </span>
            </ng-template>
            <ng-template #elseValueText>
                {{item.value}}
            </ng-template>
        </span>
    </ng-template>
</ng-select>
<div *ngIf="invalidText && (model == undefined) && (submitted == true ) && includeValidation == true"
    class='invalidInputTextMessage'>
    <div>
        {{invalidText}}
    </div>
</div>